import React, { useEffect, useState } from "react";
import styled from "styled-components";
import clsx from "clsx";

const _Cursor = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: black;
  font-size: 2em;
  width: 26px;
  height: 26px;
  border-radius: 100%;
  opacity: 0;
  transition: transform 100ms ease, width 200ms, height 200ms;
  mix-blend-mode: difference;
  pointer-events: none;
  will-change: transform;
  &.is-anchor-or-button {
    width: 50px;
    height: 50px;
    background: transparent;
    border: 1px solid;
  }
`;

const Cursor = () => {
  const [css, setCss] = useState({ x: 0, y: 0, opacity: 0 });
  const [isAnchorOrButton, setIsAnchorOrButton] = useState(false);
  useEffect(() => {
    document.addEventListener("mousemove", _onMouseMove);

    return () => document.removeEventListener("mousemove", _onMouseMove);
  }, []);

  const _onMouseMove = e => {
    const __isAnchorOrButton = _getIsAnchorOrButton(e.target);
    setIsAnchorOrButton(__isAnchorOrButton);
    // console.log(e.clientX);
    const offset = __isAnchorOrButton ? 25 : 13;
    setCss(css => ({
      ...css,
      x: e.clientX - offset,
      y: e.clientY - offset,
      opacity: 1
    }));
  };

  const _getIsAnchorOrButton = target => {
    return (
      target.tagName.toLowerCase() === "a" ||
      target.tagName.toLowerCase() === "button"
    );
  };
  // console.log(css)
  return (
    <_Cursor
      className={clsx("cursor", isAnchorOrButton ? "is-anchor-or-button" : "")}
      style={{
        transform: `translate(${css.x}px, ${css.y}px)`,
        opacity: css.opacity
      }}></_Cursor>
  );
};

export default Cursor;
